import { render, staticRenderFns } from "./barcode_approval.vue?vue&type=template&id=240a8f24&"
import script from "./barcode_approval.vue?vue&type=script&lang=js&"
export * from "./barcode_approval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports